var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.editor
        ? _c("ckeditor", {
            key: _vm.editorKey,
            ref: "editor",
            attrs: { editor: _vm.editor, config: _vm.editorConfig },
            on: {
              input: _vm.dataChanged,
              blur: _vm.onBlur,
              destroy: _vm.onDestroy,
              ready: _vm.onReady
            },
            model: {
              value: _vm.editor_data,
              callback: function($$v) {
                _vm.editor_data = $$v
              },
              expression: "editor_data"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }